<template>
    <div>
        <a-drawer
            :title="$t('program.import_program_details_drawer.import_title' /* 日程导入 */)"
            width="70%"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleCloseEvent"
        >
            <div class="flex x-right mb20">
                <a-button class="mr10" @click="getDataList">{{ $t('program.import_program_details_drawer.refresh' /* 刷新 */) }}</a-button>
                <a-button type="primary" @click="$refs.addImportProgramModal.show()">{{ $t('program.import_program_details_drawer.add_import_task' /* 新增导入任务 */) }}</a-button>
            </div>
            <a-table
                bordered
                :loading="loading"
                :rowKey="record => record.id"
                :columns="columns"
                :data-source="dataSource"
                size="middle"
                :scroll="{ x: 680 }"
                :pagination="{
                    ...pagination,
                    showTotal: total => $t('web.pagination_total', { value: total } /* 共{value}条 */)
                }"
                @change="handleTableChange"
                @showSizeChange="handleTableChange"
            >
                <template slot="status" slot-scope="text, record">
                    <a-badge :color="formatStatusColorFun(record.status)" :text="formatStatusFun(record.status)" />
                </template>
                <template slot="actions" slot-scope="text, record">
                    <a-button type="link" @click="$refs.importProgramDetailsDrawerRef.show(record.id)">{{ $t('program.import_program_details_drawer.view_details' /* 查看详情 */) }}</a-button>
                </template>
            </a-table>
            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: '100'
                }"
            >
                <a-button type="default" @click="handleCloseEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSaveEvent('save')">{{ $t('program.import_program_details_drawer.save' /* 保存 */) }}</a-button>
            </div>
        </a-drawer>
        <!-- 新增导入任务 -->
        <add-import-program-modal ref="addImportProgramModal" @refresh="getDataList" />
        <!-- 日程导入详情 -->
        <import-program-details-drawer ref="importProgramDetailsDrawerRef" @refresh="getDataList" />
    </div>
</template>
<script>
import AddImportProgramModal from './add-import-program-modal.vue';
import ImportProgramDetailsDrawer from './import-program-details-drawer.vue';
export default {
    name: 'ImportProgramDrawer',
    components: {
        AddImportProgramModal,
        ImportProgramDetailsDrawer
    },
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                {
                    title: this.$t('program.import_program_details_drawer.task_id' /* 任务ID */),
                    dataIndex: 'id',
                    width: 80
                },
                {
                    title: this.$t('program.import_program_details_drawer.task_status' /* 任务状态 */),
                    dataIndex: 'status',
                    width: 150,
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    title: this.$t('program.import_program_details_drawer.create_time' /* 创建时间 */),
                    dataIndex: 'create_time',
                    width: 150,
                    align: 'center'
                },
                {
                    title: this.$t('program.import_program_details_drawer.update_time' /* 更新时间 */),
                    dataIndex: 'update_time',
                    width: 150,
                    align: 'center'
                },
                {
                    title: this.$t('program.import_program_details_drawer.actions' /* 操作 */),
                    dataIndex: 'actions',
                    scopedSlots: { customRender: 'actions' },
                    align: 'center',
                    width: 150
                }
            ],
            dataSource: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
                showQuickJumper: true
            }
        };
    },
    methods: {
        show() {
            this.visible = true;
            this.getDataList();
        },
        handleCloseEvent() {
            this.visible = false;
        },
        /**
         * 格式化任务状态
         * @param {string} status 任务状态
         * @returns {string} 任务状态
         */
        formatStatusFun(status) {
            switch (status) {
                case '-1':
                    return this.$t('program.import_program_details_drawer.deleted' /* 已删除 */);
                case '0':
                    return this.$t('program.import_program_details_drawer.waiting_for_verification' /* 待校验 */);
                case '1':
                    return this.$t('program.import_program_details_drawer.waiting_for_import' /* 待导入 */);
                case '2':
                    return this.$t('program.import_program_details_drawer.importing' /* 导入中 */);
                case '3':
                    return this.$t('program.import_program_details_drawer.import_success' /* 导入成功 */);
                case '-2':
                    return this.$t('program.import_program_details_drawer.import_failed' /* 导入失败 */);
                case '-3':
                    return this.$t('program.import_program_details_drawer.check_failed' /* 校验失败 */);
            }
        },
        /**
         * 格式化任务状态颜色
         * @param {string} status 任务状态
         * @returns {string} 任务状态颜色
         */
        formatStatusColorFun(status) {
            switch (status) {
                case '-1':
                    return '#ddd';
                case '0':
                    return 'gold';
                case '1':
                    return 'gold';
                case '2':
                    return 'yellow';
                case '3':
                    return 'green';
                case '-2':
                    return 'red';
                case '-3':
                    return 'red';
                default:
                    return '#ddd';
            }
        },
        // 表格变化
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getDataList();
        },
        /**
         * 获取数据列表
         */
        getDataList() {
            this.loading = true;
            this.$request
                .get({ url: 'programImportList', data: { page: this.pagination.current, limit: this.pagination.pageSize } })
                .then(res => {
                    this.dataSource = res.data.list;
                    this.pagination.total = Number(res.data.count);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
</style>
